<template>
  <div class="body" @click="isShowRegister">
    <div class="head">
      <div v-if="user" @click="showRegister($event)">
                <span class="logo">
                    <img class="logoImg"
                         src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/customLogin.png">
                </span>
        <span class="title">小鸥助手后台系统</span>
        <span class="avatar">
                    <img class="logoImg" :src="user.avatar">
                </span>
        <span class="userName">{{ user.username }}</span>
      </div>
    </div>
    <div class="centent">
      <div class="left">
        <el-aside width="105%">
          <el-row class="tac">
            <el-col :span="23">
              <el-menu :defaultActive="activeMove" class="el-menu-vertical-demo" @open="handleOpen"
                       @close="handleClose">
                <div v-for="el in menus" :key="el.id"
                     @click="routeSkip(el.path)"
                >
                  <el-menu-item
                    v-if="el.sub.length <= 0"
                    :index="el.id">
                    <router-link class="link"
                                 v-if="el.path"
                                 :to="el.path"
                                 replace>
                      <i :class="el.iconClass"></i>
                      {{ el.name }}
                    </router-link>
                    <span slot="title" v-else>
                      {{ el.name }}</span>
                  </el-menu-item>
                  <el-submenu
                    v-else
                    :index="el.id">
                    <template slot="title">
                      <i :class="el.iconClass"></i>
                      <span>{{ el.name }}</span>
                    </template>
                    <el-menu-item-group>
                      <el-menu-item index="5-1"
                                    v-for="item in el.sub"
                                    :key="item.id"
                      >
                        <router-link class="link" :to="item.path" replace>{{
                            item.name
                          }}
                        </router-link>
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                </div>
              </el-menu>
            </el-col>
          </el-row>
        </el-aside>
      </div>
      <div class="right">
        <router-view/>
      </div>
    </div>
    <!--    登录退出蒙层-->
    <div class="register-quit" v-if="isQuite">
      <div class="register-quit-text" @click="cutAccount($event)">切换账号</div>
      <div class="register-quit-text"
           style="margin-bottom: 0.7rem"
           @click="ModifyPassworld($event)">更改密码
      </div>
      <div class="register-quit-text" style="margin-bottom: 0.7rem"
           @click="quitLogin($event)"
      >退出登录
      </div>
    </div>

    <!-- 重置修改用户密码 -->
    <div class="shade" v-if="isShadePassworld">
      <div class="Staff-after">
        <div class="Staff-after-title">修改员工密码</div>
        <div>
          <el-input style="width:calc(100% - 4rem);margin:0.7rem 0"
                    v-model="oldPassword"
                    minlength="8"
                    placeholder="请输入旧密码"/>
        </div>
        <div>
          <el-input style="width:calc(100% - 4rem);margin:0.7rem 0"
                    v-model="newPassword"
                    minlength="8"
                    placeholder="请输入新密码"/>
        </div>
        <div class="Staff-after-btn">
          <div class="Staff-after-btn-single"
               style="border:1px solid #DCDFE6"
               @click="cancelAmendPassword()"
          >
            取消
          </div>
          <div class="Staff-after-btn-single"
               style="background-color: #0e77ca;color:white"
               @click="confirmAmendPassword()"
          >
            确定
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "../../axios/axios";
import ipAddress from "../../axios/ipAddress";
import {Message} from "element-ui";

export default {
  data() {
    return {
      user: null,
      menus: [
        {
          path: "/index/dataStatis",
          name: "数据统计",
          sub: [],
          id: "1",
          iconClass: 'el-icon-s-data'
        },
        {
          path: "/index/customer",
          name: "客户管理",
          sub: [],
          id: "2",
          iconClass: 'el-icon-s-custom'
        },
        {
          path: "/index/departMent",
          name: "部门管理",
          sub: [],
          id: "3",
          iconClass: 'el-icon-s-grid'
        },
        {
          path: "/index/staff",
          name: "员工管理",
          sub: [],
          id: "4",
          iconClass: 'el-icon-user-solid'
        },
        {
          path: null,
          name: "发放管理",
          sub: [
            {
              path: "/index/grantCard",
              name: "会员卡",
              id: "5-1",
              parentId: '5'
            },
            {
              path: "/index/grantReceipt",
              name: "收据",
              id: "5-2",
              parentId: '5'
            },
            {
              path: "/index/grantGitf",
              name: "礼品",
              id: "5-3",
              parentId: '5'
            },
            {
              path: "/index/grantProduct",
              name: "产品",
              id: '5-4',
              parentId: '5'
            }
          ],
          iconClass: "el-icon-document",
          id: "5"
        },
        {
          path: null,
          name: "报表管理",
          sub: [],
          id: "7",
          iconClass: 'el-icon-s-order'
        },
        {
          path: null,
          name: "系统设置",
          sub: [],
          id: "8",
          iconClass: 'el-icon-s-tools'
        },
        {
          path: "/index/CustPool",
          name: "客户池",
          sub: [],
          id: "9",
          iconClass: 'el-icon-s-check'
        },
      ],
      activeMove: "0",  //激活菜单的index
      isQuite: false,
      isShadePassworld: false,
      oldPassword: '',
      newPassword: ''
    }
  },
  computed: {},
  mounted() {
    this.userInfo()
    this.nav_highlight()
  },
  methods: {
    //用户信息
    userInfo() {
      var user = JSON.parse(localStorage.getItem('user'))
      var token = localStorage.getItem('token')
      var optionId = localStorage.getItem('optionId')
      this.user = user
    },

    //路由有导航栏高亮问题
    nav_highlight() {
      //获取当前路由地址
      const url = this.$route.path
      //刷新后父级判断
      const index = this.menus.findIndex(el => el.path == url)
      if (index === -1) {
        //刷新后子级的判断
        let subMenus = this.menus.map(el => el.sub.filter(date => date.path == url))
        let subMenu = [];
        subMenus.forEach(el => {
          el.forEach(item => {
            if (item) {
              subMenu.push(item)
            }
          })
        })
        let [subMenusv] = subMenu
        if (subMenusv) {
          this.activeMove = subMenusv.parentId
        }
      } else {
        this.activeMove = this.menus[index].id
      }
    },

    handleOpen(key, keyPath) {
    },
    handleClose(key, keyPath) {
    },
    //点击显示操作界面
    showRegister(event) {
      //阻止冒泡事件
      window.event ? window.event.cancelBubble = true : event.stopPropagation();
      this.isQuite = !this.isQuite
    },
    //点击是否显示操作
    isShowRegister() {
      this.isQuite = false
    },
    //点击切换账号
    cutAccount(event) {
      //阻止冒泡事件
      window.event ? window.event.cancelBubble = true : event.stopPropagation();
      this.$router.replace({path: '/login'})
    },
    //点击退出登录
    quitLogin(event) {
      //阻止冒泡事件
      window.event ? window.event.cancelBubble = true : event.stopPropagation();
      axios.post(`${ipAddress.qi}/admin/a1/quit/logout`).then(value => {
        const success = value.content
        if (success) {
          window.localStorage.removeItem("user")  //清空用户信息
          window.localStorage.removeItem("token") //清空token信息
          this.$router.replace({path: '/login'})  //跳转登录页面
        } else {
          const msg = value.message
          Message.error(msg)
        }
      })

    },
    //点击路由跳转
    routeSkip(path) {
      if (path == '/index/customer') {
        window.localStorage.setItem("clientPage", '1')
      }
    },
    //点击更改密码
    ModifyPassworld(event){
      //阻止冒泡事件
      window.event ? window.event.cancelBubble = true : event.stopPropagation();
      this.isShadePassworld = true
    },
    //点击取消修改密码
    cancelAmendPassword(){
      this.isShadePassworld = false;
    },
    //点击确认修改密码
    confirmAmendPassword(){
      if(this.oldPassword && this.oldPassword.length < 8){
        Message.warning("输入旧密码对应格式")
        return;
      }
      if(this.newPassword && this.newPassword.length < 8){
        Message.warning("输入新密码对应的格式")
        return;
      }
      let params = new URLSearchParams()
      params.set("staffId",this.user.id)
      params.set("oldPassword",this.oldPassword)
      params.set("newPassword",this.newPassword)
      axios.post(`${ipAddress.qi}/admin/a1/staff/modify/admin/passworld`,params).then(value =>{
        const success = value.success
        if(success){
          Message.success("修改成功")
          window.localStorage.removeItem("user")  //清空用户信息
          window.localStorage.removeItem("token") //清空token信息
          this.$router.replace({path: '/login'})  //跳转登录页面
        }else {
          const msg = value.message
          Message.error(msg)
        }
      })
    }
  }
}
</script>


<style>
.body {
  height: 100%;
}

.head {
  /* height: 80px; */
  background-color: #ffffff;
  height: 8%;
  width: calc(100% - 10px);
  /* background-color: ; */
  position: relative;
}

.register-quit {
  position: absolute;
  top: 7.5%;
  right: 3%;
  width: auto;
  height: auto;
  z-index: 10;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.7);
}

.register-quit-text {
  padding: 0 0.7rem;
  color: white;
  letter-spacing: 2px;
  font-size: 0.95rem;
  margin-top: 0.7rem;
}

.centent {
  height: 90%;
}

.left {
  float: left;
  /* background-color: antiquewhite; */
  width: 10%;
}

.right {
  float: left;
  background-color: #EFF1F3;
  width: 90%;
  height: 100%;
}


.el-header, .el-footer {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  height: 100px;
  line-height: 60px;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
  line-height: 160px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

/*  */
.header {
  height: 100px;
}

.logo {
  display: inline-block;
  line-height: 80px;
  width: 5%;
  /* background-color: aqua; */
  vertical-align: middle;
}

.logoImg {
  width: 50px;
  width: 50px;
  vertical-align: middle;
  border-radius: 100%;
  /* background-color: #B3C0D1; */
}

.title {
  display: inline-block;
  width: 80%;
  text-align: left;
  /* background-color:beige; */
  font-size: 18px;
  font-weight: 600
}

.avatar {
  display: inline-block;
  width: 5%;
  /* background-color:blue; */
}

.userName {
  display: inline-block;
  width: 5%;
  /* background-color:brown; */
}

.link {
  color: #333;
}

.shade {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}

.Staff-after {
  height: auto;
  width: auto;
  z-index: 10;
  background-color: white;
  border-radius: 5px;
}

.Staff-after-title {
  letter-spacing: 2px;
  font-size: 0.95rem;
  width: 20rem;
  height: auto;
  position: relative;
  padding: 0.7rem 0;
}

.Staff-after-btn {
  width: calc(100% - 4rem);
  margin: auto;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem 0;
}

.Staff-after-btn-single {
  font-size: 0.95rem;
  letter-spacing: 2px;
  border-radius: 5px;
  background-color: white;
  padding: 0.6rem 1.4rem;
}


</style>



// WEBPACK FOOTER //
// src/components/Index/index.vue